module.exports = __webpack_public_path__ + "static/media/circle2.2741cd67.png";